module.exports = __webpack_public_path__ + "static/media/homeArchitect.78765582.svg";